import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientGoogleReviews"] */ "/vercel/path0/src/components/sections/client-google-reviews.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/testimonials.tsx");
